<template>
	<div class="index" v-loading="loading">
		<!-- 状态控制与查询区域 -->
		<div class="stats">
			<!-- 第一行：在线人数 + 三个开关（横向排列） -->
			<div class="top-controls-row">
				<!-- 在线人数显示 -->
				<div class="online-num-wrap">
					当前在线人数：<span class="online-num-value">{{ onlineNum }}<i class="el-icon-s-custom"></i></span>
				</div>

				<!-- 网站状态开关 -->
				<el-switch v-model="webStatus" :active-value="true" :inactive-value="false" active-text="网站开启" inactive-text="网站拉闸"
					active-color="#67C23A" inactive-color="#F56C6C" @change="changeWebStatus"></el-switch>

				<!-- 对战状态开关 -->
				<el-switch v-model="battleStatus" :active-value="true" :inactive-value="false" active-text="对战开启" inactive-text="对战拉闸"
					active-color="#67C23A" inactive-color="#F56C6C" @change="changeBattleStatus"></el-switch>

				<!-- 提取状态开关 -->
				<el-switch v-model="extractStatus" :active-value="true" :inactive-value="false" active-text="提取开启" inactive-text="提取拉闸"
					active-color="#67C23A" inactive-color="#F56C6C" @change="changeExtractStatus"></el-switch>
			</div>

			<!-- 第二行：日期选择 + 查询按钮（横向排列） -->
			<div class="date-query-row">
				<!-- 开始日期 -->
				<el-date-picker v-model="params.start_time" type="datetime" placeholder="开始日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>

				<!-- 结束日期 -->
				<el-date-picker v-model="params.end_time" type="datetime" placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>

				<!-- 查询按钮 -->
				<el-button type="primary" @click="getStatsData">查询</el-button>

				<!-- 注释按钮保留，如需启用可删除注释 -->
				<!-- <el-button type="primary" @click="handleExport">24小时掉落饰品</el-button>
        <el-button type="primary" @click="gameRanking">对战排行</el-button>
        <el-button type="primary" @click="profitCache" :loading="bottonLoading">利润缓存</el-button>
        <el-button type="primary" @click="exportKnapsack">导出背包</el-button> -->
			</div>

			<!-- 数据提示文本 -->
			<p class="prompt">默认展示当天数据</p>

			<!-- 统计数据卡片区域（数据存在时显示） -->
			<el-row :gutter="20" v-if="statsData" class="stats-card-row">
				<!-- 新注册 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>新注册</span>
						</div>
						<div class="card-value">{{ statsData.register_num }}</div>
					</el-card>
				</el-col>

				<!-- 充值金额 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>充值金额</span>
						</div>
						<div class="card-value">{{ statsData.recharge_amount }}</div>
					</el-card>
				</el-col>

				<!-- CDK充值金额 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>CDK充值金额</span>
						</div>
						<div class="card-value">{{ statsData.recharge_cdk_amount }}</div>
					</el-card>
				</el-col>

				<!-- ZBT充值CDK -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>ZBT充值CDK</span>
						</div>
						<div class="card-value">{{ statsData.cdk_307 }}</div>
					</el-card>
				</el-col>

				<!-- 主播工资CDK -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>主播工资CDK</span>
						</div>
						<div class="card-value">{{ statsData.cdk_308 }}</div>
					</el-card>
				</el-col>

				<!-- 转赠CDK -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>转赠CDK</span>
						</div>
						<div class="card-value">{{ statsData.cdk_309 }}</div>
					</el-card>
				</el-col>

				<!-- USDT充值CDK -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>USDT充值CDK</span>
						</div>
						<div class="card-value">{{ statsData.cdk_310 }}</div>
					</el-card>
				</el-col>



				<!-- USDT支付 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>USDT支付</span>
						</div>
						<div class="card-value">{{ statsData.usdt }}</div>
					</el-card>
				</el-col>
				
				<!-- 汇禾-支付宝 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>汇禾-支付宝</span>
						</div>
						<div class="card-value">{{ statsData.huihe }}</div>
					</el-card>
				</el-col>
				<!-- 考拉-支付宝 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>考拉2-支付宝</span>
						</div>
						<div class="card-value">{{ statsData.kaola2_zfb }}</div>
					</el-card>
				</el-col>
				
				<!-- 悠米-微信 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>悠米-微信</span>
						</div>
						<div class="card-value">{{ statsData.youmi }}</div>
					</el-card>
				</el-col>

				<!-- 畅享-支付宝 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>畅享-支付宝</span>
						</div>
						<div class="card-value">{{ statsData.changxiang }}</div>
					</el-card>
				</el-col>

				<!-- 畅享-支付宝 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>畅享-支付宝2</span>
						</div>
						<div class="card-value">{{ statsData.cs_zfb }}</div>
					</el-card>
				</el-col>
				
				<!-- cs-微信 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>畅享-微信</span>
						</div>
						<div class="card-value">{{ statsData.cs_wx }}</div>
					</el-card>
				</el-col>

				<!-- M9 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header chongzhi">
							<span>M9</span>
						</div>
						<div class="card-value">{{ statsData.M9 }}</div>
					</el-card>
				</el-col>

				<!-- zbt提取 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>zbt提取</span>
						</div>
						<div class="card-value">{{ statsData.ext_zbt }}</div>
					</el-card>
				</el-col>

				<!-- pzh提取 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>pzh提取</span>
						</div>
						<div class="card-value">{{ statsData.ext_pzh }}</div>
					</el-card>
				</el-col>

				<!-- mds提取 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>mds提取</span>
						</div>
						<div class="card-value">{{ statsData.ext_mds }}</div>
					</el-card>
				</el-col>

				<!-- 提取进行中 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>提取进行中</span>
						</div>
						<div class="card-value">{{ statsData.ext_ext }}</div>
					</el-card>
				</el-col>

				<!-- 总提取 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header zongtiqu">
							<span>总提取</span>
						</div>
						<div class="card-value">{{ statsData.ext_all }}</div>
					</el-card>
				</el-col>

				<!-- 转赠中 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>转赠中</span>
						</div>
						<div class="card-value">{{ statsData.ext_998 }}</div>
					</el-card>
				</el-col>

				<!-- 已转赠 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>已转赠</span>
						</div>
						<div class="card-value">{{ statsData.ext_999 }}</div>
					</el-card>
				</el-col>

				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>官方转赠</span>
						</div>
						<div class="card-value">{{ statsData.transfer2 }}</div>
					</el-card>
				</el-col>

				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>朝歌转赠</span>
						</div>
						<div class="card-value">{{ statsData.transfer1 }}</div>
					</el-card>
				</el-col>

				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>金铲铲转赠</span>
						</div>
						<div class="card-value">{{ statsData.transfer3 }}</div>
					</el-card>
				</el-col>

				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>kk转赠</span>
						</div>
						<div class="card-value">{{ statsData.transfer4 }}</div>
					</el-card>
				</el-col>

				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>江南转赠</span>
						</div>
						<div class="card-value">{{ statsData.transfer5 }}</div>
					</el-card>
				</el-col>

				<!-- M9币待发货 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>M9币待发货</span>
						</div>
						<div class="card-value">{{ statsData.m9_0 }}</div>
					</el-card>
				</el-col>

				<!-- M9币已发货 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header fahuotiqu">
							<span>M9币已发货</span>
						</div>
						<div class="card-value">{{ statsData.m9_1 }}</div>
					</el-card>
				</el-col>

				<!-- 充值人数 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>充值人数</span>
						</div>
						<div class="card-value">{{ statsData.reg_number }}</div>
					</el-card>
				</el-col>

				<!-- 提取人数 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>提取人数</span>
						</div>
						<div class="card-value">{{ statsData.ext_number }}</div>
					</el-card>
				</el-col>

				<!-- 活跃人数 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>活跃人数</span>
						</div>
						<div class="card-value">{{ statsData.all_number }}</div>
					</el-card>
				</el-col>

				<!-- 背包价值总和 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>背包价值总和</span>
						</div>
						<div class="card-value">{{ statsData.user_backpack_amount }}</div>
					</el-card>
				</el-col>

				<!-- 钻石总和 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>钻石总和</span>
						</div>
						<div class="card-value">{{ statsData.user_account_balance }}</div>
					</el-card>
				</el-col>

				<!-- 商城币总和 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>商城币总和</span>
						</div>
						<div class="card-value">{{ statsData.user_shop_balance }}</div>
					</el-card>
				</el-col>

				<!-- 钥匙价值总和 -->
				<el-col :xs="8" :sm="6" :md="4" :lg="3" class="stats-card-col">
					<el-card class="box-card">
						<div slot="header" class="card-header">
							<span>钥匙价值总和</span>
						</div>
						<div class="card-value">{{ statsData.user_exp_boxes_price }}</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import http, { getApiData, patchApiData, postApiData, server, api } from '../../http'
	export default {
		data() {
			return {
				loading: false,
				bottonLoading: false, //按钮动画
				webStatus: true, //网站开启或关闭状态
				battleStatus: true, //对战开启或关闭状态
				extractStatus: true, //对战开启或关闭状态
				statsData: undefined,
				onlineNum: '', //当前在线总人数
				params: {
					id: undefined,
					start_time: undefined,
					end_time: undefined
				}
			}
		},
		created() {
			this.getOnlineNum() //获取当前在线人数
			this.getWebStatus() //获取官网网站状态
			this.getStatsData() //拿取总览数据
		},
		methods: {
			getOnlineNum() {
				// 获取当前在线人数
				getApiData('onlineNum')
					.then(res => {
						this.onlineNum = res
					})
			},
			getWebStatus() {
				//获取官网网站状态
				getApiData('get_all_config')
					.then(res => {
						this.webStatus = res.web_status;
						this.battleStatus = res.battle_status;
						this.extractStatus = res.extract_status;
					})
			},
			changeWebStatus() {
				//关闭或者开启官网网站
				this.$confirm(`确认${this.webStatus ? '打开' : '关闭'}网站？`, '重要提示！', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						type: 'web',
						black: this.webStatus
					}
					patchApiData('get_all_config', params)
						.then(res => {
							this.getWebStatus() //刷新数据
							this.$message.success("操作成功！")
						})
				}).catch(() => {
					this.webStatus = !this.webStatus
				})
			},
			changeBattleStatus() {
				//关闭或者开启官网网站
				this.$confirm(`确认${this.webStatus ? '打开' : '关闭'}对战？`, '重要提示！', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						type: 'battle',
						black: this.battleStatus
					}
					patchApiData('get_all_config', params)
						.then(res => {
							this.getWebStatus() //刷新数据
							this.$message.success("操作成功！")
						})
				}).catch(() => {
					this.webStatus = !this.webStatus
				})
			},
			changeExtractStatus() {
				//关闭或者开启官网网站
				this.$confirm(`确认${this.extractStatus ? '打开' : '关闭'}提取？`, '重要提示！', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						type: 'extract',
						black: this.extractStatus
					}
					patchApiData('get_all_config', params)
						.then(res => {
							this.getWebStatus() //刷新数据
							this.$message.success("操作成功！")
						})
				}).catch(() => {
					this.webStatus = !this.webStatus
				})
			},
			getStatsData() {
				this.loading = true
				getApiData('index_statistics', this.params)
					.then(res => {
						this.statsData = res
					})
					.finally(() => {
						this.loading = false
					})
			},
			handleExport() {
				//24小时掉落
				window.open(`${api}export`)
			},
			gameRanking() {
				//对战排行导出
				window.open(`${api}export_battle`)
			},
			profitCache() {
				//利润缓存
				this.bottonLoading = true
				getApiData('index_cache', this.params)
					.then(res => {
						if (res.code === 0) {
							this.$message.success(res.message)
						} else if (res.code === 1) {
							this.$message.error(res.message)
						}
					})
					.finally(() => {
						this.bottonLoading = false
					})
			},
			exportKnapsack() {
				//导出背包
				window.open(`${api}backpack_export?start_time=${this.params.start_time}&end_time=${this.params.end_time}`)
			}
		}
	}
</script>

<style type="scss">
	/* 外层容器基础样式 */
.index {
  padding: 20px;
  box-sizing: border-box;
}

/* 统计区域外层容器 */
.stats {
  width: 100%;
}

/* 第一行：在线人数 + 三个开关 统一容器 */
.top-controls-row {
  display: flex;
  align-items: center;
  gap: 30px; /* 元素之间间距 */
  margin-bottom: 20px;
  flex-wrap: wrap; /* 小屏幕自动换行，避免溢出 */
}

/* 在线人数样式 */
.online-num-wrap {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #2080ee;
}

.online-num-value {
  color: #67c23a;
  margin-left: 4px;
  display: flex;
  align-items: center;
}

.online-num-value .el-icon-s-custom {
  margin-left: 6px;
  font-size: 16px;
}

/* 开关样式调整：统一高度和间距 */
.top-controls-row .el-switch {
  display: flex;
  align-items: center;
  height: 32px; /* 与在线人数文字高度对齐 */
}

.top-controls-row .el-switch__label {
  font-size: 14px;
  padding: 0 8px;
}

/* 第二行：日期选择 + 查询按钮 统一容器 */
.date-query-row {
  display: flex;
  align-items: center;
  gap: 20px; /* 元素之间间距 */
  margin-bottom: 20px;
  flex-wrap: wrap; /* 小屏幕自动换行 */
}

/* 日期选择器样式：统一宽度和高度 */
.date-query-row .el-date-picker {
  width: 220px; /* 固定宽度，保持整齐 */
}

/* 查询按钮样式微调 */
.date-query-row .el-button--primary {
  padding: 0 24px;
}

/* 提示文本样式 */
.prompt {
  color: #666;
  font-size: 13px;
  margin-bottom: 20px;
  margin-top: -10px;
}

/* 统计卡片区域行容器：修复卡片换行间距 */
.stats-card-row {
  margin-bottom: 20px;
}

/* 统计卡片列容器：控制卡片间距 */
.stats-card-col {
  margin-bottom: 20px;
}

/* 卡片基础样式 */
.box-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 卡片头部样式 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  border-radius: 4px 4px 0 0;
}

/* 充值相关卡片头部背景 */
.chongzhi {
  background-color: seagreen;
  color: #eee;
}

/* 发货提取相关卡片头部背景 */
.fahuotiqu {
  background-color: darkred;
  color: #eee;
}

/* 总提取卡片头部背景 */
.zongtiqu {
  background-color: pink;
  color: #333;
}

/* 卡片数值样式 */
.card-value {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: #333;
  padding: 15px 0;
}

/* 加载状态覆盖层调整 */
.el-loading-mask {
  z-index: 100;
}

/* 响应式适配：小屏幕（如平板）调整 */
@media (max-width: 1200px) {
  .top-controls-row {
    gap: 20px;
  }

  .date-query-row {
    gap: 15px;
  }

  .date-query-row .el-date-picker {
    width: 180px;
  }
}

/* 响应式适配：手机屏幕调整 */
@media (max-width: 768px) {
  .top-controls-row {
    gap: 15px;
  }

  .date-query-row .el-date-picker {
    width: 100%;
    max-width: 300px;
  }

  .card-value {
    font-size: 18px;
  }
}
/* 放大查询按钮样式 */
.date-query-row .el-button--primary {
  padding: 10px 30px; /* 增加内边距，横向纵向都放大 */
  font-size: 16px;   /* 增大字体 */
  height: 40px;      /* 增加按钮高度，与日期选择器对齐 */
}
</style>